export const PageAbout = () => {
  return <div className="min-h-screen bg-base-200">About</div>;
}

